// extracted by mini-css-extract-plugin
export default {"formWrapper":"CategoriesAlertDialog_formWrapper__50ZB8","select":"CategoriesAlertDialog_select__HFySP"};